import React, { useState } from "react";

import GreyTable from '../../../../components/Tables/GreyTable'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { useTheme } from '../../../../Themecontext/Themecontext';

export const BalanceQuality = ({ Muldata }) => {



  const { AccountToPGroupListData } = useSelector((state) => state.PartyProfileSlice);
  const { BalQualityData } = useSelector((state) => state.PartyProfileSlice);

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  const columns = [
    // { Header: "Chart", accessor: "chartButton", width: "60px" },
    { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Itemname", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "ItemwTotal", label: "Grand Total", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "MonthNYearName", label: "Month", align: "right", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "BalMeter", label: "Meter", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "01", label: "1", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "02", label: "2", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "03", label: "3", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "04", label: "4", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "05", label: "5", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "06", label: "6", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "07", label: "7", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "08", label: "8", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "09", label: "9", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "10", label: "10", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "11", label: "11", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "12", label: "12", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "13", label: "13", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "14", label: "14", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "15", label: "15", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "16", label: "16", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "17", label: "17", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "18", label: "18", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "19", label: "19", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "20", label: "20", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "21", label: "21", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "22", label: "22", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "23", label: "23", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "24", label: "24", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "25", label: "25", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "26", label: "26", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "27", label: "27", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "28", label: "28", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "29", label: "29", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "30", label: "30", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "31", label: "31", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];


  const Date = [
    "ItemwTotal",
    "BalMeter",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
  ];


  const formattedRows = BalQualityData?.BalQuality?.map((row, index, arr) => {
    const totalLength = arr.length.toString().length;
    const formattedRow = {
      // srNumber: (index + 1).toString().padStart(totalLength, "0"),
      id: index,
      ...row,
    };

    Date.forEach((accessor) => {
      formattedRow[accessor] = row[accessor];
    });

    return formattedRow;
  });


  return (
    <>
      <div>
        <Row>
          <Col>
            <>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour8,
                    padding: "14px",
                  }}
                >
                  <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px",fontWeight:"700" }}>
                    MERGING
                  </h2>
                </div>
                <GreyTable columns={columns} data={formattedRows} iscolourDark={iscolourDark}
                  iscolour={iscolour} />
              </div>
            </>


            {Muldata?.map((el) => {
              const formattedRows1 = el?.BalQuality?.map((row, index, arr) => {
                const formattedRow = {
                  srNumber: (index + 1)
                    .toString()
                    .padStart(arr.length.toString().length, "0"),
                  id: index,
                  ...row,
                };

                Date.forEach((accessor) => {
                  formattedRow[accessor] = row[accessor];
                });

                return formattedRow;
              });
              return (
                <>
                  <div
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                      marginTop: "20px"
                    }}
                  >
                    <div
                      style={{
                        backgroundColor:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour8,
                        padding: "14px",
                      }}
                    >
                      <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px" ,fontWeight:"700"}}>
                        {AccountToPGroupListData?.Data?.find(
                          (nel) => Number(el.group) === Number(nel.ProductionGroupMstID)
                        )?.ProductionGroupMstName || `Group ${el.group}`}
                      </h2>
                    </div>

                    <GreyTable columns={columns} data={formattedRows1} iscolourDark={iscolourDark}
                      iscolour={iscolour} />
                  </div>
                </>
              );
            })}
          </Col >
        </Row>
      </div>
    </>
  )
}


